module.exports = __webpack_public_path__ + "img/ford-Used.9e9887ad.png";